import template from './template.html'

angular.module('contabilidad.polizas')
  .config(['$stateProvider', Config])

function Config ($stateProvider) {
  $stateProvider.state('contabilidad.polizas.provisiongastos', {
    url: '/provisiongastos?{fecha_inicio:date}&{fecha_fin:date}&:ids_clientes',
    template,
    data: {
      title: 'Póliza de Provisión de Gastos',
    },
    params: {
      ids_clientes: {
        array: true,
      },
    },
    resolve: {
      clientes: ['$catalogos', function ($catalogos) {
        return $catalogos.get('clientes')
      }],
      polizas: ['ProvisionGastosService', '$stateParams', function (ProvisionGastosService, $stateParams) {
        var fecha_inicio = $stateParams.fecha_inicio,
          fecha_fin = $stateParams.fecha_fin,
          ids_clientes = $stateParams.ids_clientes

        return fecha_inicio && fecha_fin && ids_clientes ? ProvisionGastosService.obtenerInformacion(
          fecha_inicio,
          fecha_fin,
          ids_clientes,
        ) : undefined
      }],
    },
    controllerAs: '$ctrl',
    controller: Controller,
  })
}

Controller.$inject = ['$stateParams', 'clientes', 'polizas', '$location', '$dialog']

function Controller ($stateParams, clientes, polizas, $location, $dialog) {
  var $ctrl = this
  $ctrl.clientes = clientes
  $ctrl.data = polizas


  if ($ctrl.data && $ctrl.data.length) {
    $ctrl.data.forEach(function (item) {
      item.transacciones.forEach(function (valor, indice) {
        if (indice === 3 && !valor.naturaleza) valor.naturaleza = 'A'
      })
      item.abono = item.transacciones.reduce(function (valor, item) {
        return item.naturaleza === 'A' ? valor + (+item.importe) : valor
      }, 0)
      item.carga = item.transacciones.reduce(function (valor, item) {
        return item.naturaleza === 'C' ? valor + (+item.importe) : valor
      }, 0)
      item.carga.toFixed(2)
      item.abono.toFixed(2)
    })
  }
  $ctrl.opciones = {
    fecha_inicio: $stateParams.fecha_inicio || new Date(),
    fecha_fin: $stateParams.fecha_fin || new Date(),
    clientes: $stateParams.ids_clientes || [],
  }

  $ctrl.obtenerInformacion = obtenerInformacion
  $ctrl.exportar = exportar

  function obtenerInformacion () {
    $location.search({
      fecha_inicio: $ctrl.opciones.fecha_inicio.toYMD(),
      fecha_fin: $ctrl.opciones.fecha_fin.toYMD(),
      ids_clientes: $ctrl.opciones.clientes,
    })
  }

  function exportar () {
    $dialog.show('contabilidad.polizas.exportar', {
      data: $ctrl.data,
      fecha_inicio: $ctrl.opciones.fecha_inicio,
      // Se agregó ésta propiedad para indicar qué es lo que se va a exportar
      config: {
        fecha_inicio: $ctrl.opciones.fecha_inicio,
        fecha_fin: $ctrl.opciones.fecha_fin,
        clientes: $ctrl.clientes.filter(function (item) {
          return $ctrl.opciones.clientes.indexOf(item.ID_Cliente) >= 0 ? item : undefined
        }),
        archivo: 'ProvisionPagos' + $ctrl.opciones.fecha_inicio.toYMD(),
        tipo_poliza: 'provisionpagos',
      },
    })
  }
}



// WEBPACK FOOTER //
// ./src/contabilidad/polizas/components/provisiongastos/component.js